import dayjs from "dayjs";
import {BankAccountType} from "../../../../declarations";

interface DevCardPreset {
  cardNumber: string;
  name: string;
  expirationDate: string;
  cvv: string;
  zip: string;
  email: string;
}

interface DevAchPreset {
  name: string;
  routingNumber: string;
  accountNumber: string;
  accountType: BankAccountType;
  email: string;
}

const DEV_TEST_NAME = "Gal Gadot";
const DEV_TEST_EMAIL = "galgadot@finbounce.com";
const DEV_TEST_CARD_NUMBERS = ["4444333322221111", "4761344136141390"];
const DEV_TEST_ACH_NUMBERS = ["021000021", "123456780"];
const DEV_TEST_ACCOUNT_TYPE: BankAccountType = "PersonalChecking";

const MIN_CVV = 100;
const MAX_CVV = 999;
const MIN_ZIP = 10000;
const MAX_ZIP = 99999;
const MIN_YEARS_AHEAD = 1;
const MAX_YEARS_AHEAD = 5;
const MONTHS_IN_YEAR = 12;

const randomIntInclusive = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min;

const randomFrom = <T>(options: T[]): T => options[randomIntInclusive(0, options.length - 1)];

const randomFutureExpirationDate = () => {
  const month = randomIntInclusive(1, MONTHS_IN_YEAR);
  const year = dayjs().year() + randomIntInclusive(MIN_YEARS_AHEAD, MAX_YEARS_AHEAD);
  return `${String(month).padStart(2, "0")}${String(year).slice(-2)}`;
};

export const buildDevCardPreset = (): DevCardPreset => ({
  cardNumber: randomFrom(DEV_TEST_CARD_NUMBERS),
  name: DEV_TEST_NAME,
  expirationDate: randomFutureExpirationDate(),
  cvv: String(randomIntInclusive(MIN_CVV, MAX_CVV)),
  zip: String(randomIntInclusive(MIN_ZIP, MAX_ZIP)),
  email: DEV_TEST_EMAIL,
});

export const buildDevAchPreset = (): DevAchPreset => {
  const achNumber = randomFrom(DEV_TEST_ACH_NUMBERS);

  return {
    name: DEV_TEST_NAME,
    routingNumber: achNumber,
    accountNumber: achNumber,
    accountType: DEV_TEST_ACCOUNT_TYPE,
    email: DEV_TEST_EMAIL,
  };
};
